import { ClientTelerikReportPage } from "../components/ClientTelerikReportPage";
import { CLIENTS_ALL_ROLES } from "../../SharedModule/utils/constants";

export const ClientAdvocacyDetailReportPage = () => (
  <ClientTelerikReportPage
    documentTitle="The Hub - Advocacy Detail Report"
    reportTitle="Advocacy Detail Report"
    reportName="ClientAdvocacyDetailSummary.trdp"
    allowedRoles={CLIENTS_ALL_ROLES}
    parametersAreaVisible={false}
  />
);
